import Icon from 'veui/components/Icon'
import { IconArrowDownSolid } from 'dls-icons-vue'

Icon.register('arrow-down-solid', IconArrowDownSolid)
